import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ExecuteCommandService } from './execute-command.service';
import { ValidationResultsService } from './validation-results.service';
import { ActionLinksPanelService } from './action-links-panel.service';
import { ClientSessionService } from './client-session.service';
import { BusyService } from './busy.service';
import { ApiService } from '../data/ApiService.generated';
import { UnsavedChangesDialogService } from './unsaved-changes-dialog.service';
import { NotificationService } from './notification.service';
import { SearchGridService } from './search-grid.service';
import { TabService } from './tab.service';
import { AlertDialogService, AlertConfirmOptions } from './alert-dialog.service';
import { SweetAlertIcon } from 'sweetalert2';

@Injectable()
export class PageContainerService {

  handleNavigationEnd() {
    this.validationResultsService.reset();
    this.notificationService.removePersistents();
    this.searchGridService.clearSubscribers();
  }

  constructor(
    public clientSessionService: ClientSessionService,
    public executeCommandService: ExecuteCommandService,
    public actionLinksPanelService: ActionLinksPanelService,
    public validationResultsService: ValidationResultsService,
    public busyService: BusyService,
    public router: Router,
    public apiService: ApiService,
    public unsavedChangesDialogService: UnsavedChangesDialogService,
    public notificationService: NotificationService,
    public searchGridService: SearchGridService,
    public tabService: TabService,
    public alertDialogService: AlertDialogService
  ) { }

  showUnsavedChangesDialog(): Promise<boolean> {
    var promise = this.unsavedChangesDialogService.showDialog();
    return promise;
  }

  showUnsavedChangesDialogWithSaveButton(showSaveButton: boolean = false): Promise<'stay' | 'discard' | 'save'> {
    var promise = this.unsavedChangesDialogService.showDialogWithSaveButton(showSaveButton);
    return promise;
  }

  alert(message: string, title?: string, icon?: SweetAlertIcon): Promise<void> {
    return this.alertDialogService.alert(message, title, icon);
  }

  confirm(message: string, title?: string, options?: AlertConfirmOptions): Promise<boolean> {
    return this.alertDialogService.confirm(message, title, options);
  }
}
